var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon ",
    clipPath: "url(#clip0_1_570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.963 25.9997H2.37067C1.06167 25.9997 0 24.8914 0 23.5232V4.95186C0 3.58442 1.06089 2.47536 2.37067 2.47536H4.74133V3.71361C4.74133 5.08105 5.80222 6.19011 7.112 6.19011H14.2232C15.5322 6.19011 16.5939 5.08186 16.5939 3.71361V2.47536H18.9646C20.2736 2.47536 21.3352 3.58361 21.3352 4.95186V23.5232C21.3352 24.8906 20.2743 25.9997 18.9646 25.9997H18.963ZM3.55522 18.8805V20.7379H13.0363V18.8805H3.55522ZM3.55522 14.5475V16.4049H17.7777V14.5475H3.55522ZM3.55522 10.2136V12.071H17.7777V10.2136H3.55522ZM13.0371 3.7128H8.29656C7.64167 3.7128 7.11122 3.15867 7.11122 2.47455V1.2363C7.11122 0.552172 7.64167 -0.00195312 8.29656 -0.00195312H13.0371C13.692 -0.00195312 14.2224 0.552172 14.2224 1.2363V2.47455V2.47617C14.2224 3.1603 13.692 3.71442 13.0371 3.71442V3.7128Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 26
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.ad589d322dce494a0e9a8ef097544e64.svg";
export { ForwardRef as ReactComponent };